export default __webpack_public_path__ + "static/media/noun_badge_799025_stroke@3x.70977fe6.png";